import { useEffect, useState } from 'react';

/**
 * Delays a fast-changing value so typing does not fire a request per keystroke.
 * The timer resets on every change, so the value settles only after a pause.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);

    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
